import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_PAYMENT_ESTIMATION_DATA_LISTS } from "../services/get-payment-estimation-data-lists";
import { GET_FEE_SCHEDULE_DATA_LISTS } from "../services/get-fee-schedule-data-lists";
import { GET_PAYER_GROUP_TYPE_LIST } from "../services/get-payer-group-type-list";
import { GET_PAYER_GROUPS_LIST } from "../services/get-payer-groups-list";
import { GET_SYSTEM_PAYERS_MAPPING_LIST } from "../services/get-system-payers-mapping-list";
import { cloneDeep } from "lodash";

export const TOGGLE_PAYER_GROUP_DETAIL_POPUP =
  "TOGGLE_PAYER_GROUP_DETAIL_POPUP";
export const RESET_PAYER_GROUP_DETAIL_POPUP_VALIDATION =
  "RESET_PAYER_GROUP_DETAIL_POPUP_VALIDATION";
export const SET_PAYER_GROUP_FORM_DATA = "SET_PAYER_GROUP_FORM_DATA";
export const TOGGLE_PAYER_GROUP_WARNING_POPUP =
  "TOGGLE_PAYER_GROUP_WARNING_POPUP";
export const CLOSE_PAYER_GROUP_POP_UP_AFTER_SAVE =
  "CLOSE_PAYER_GROUP_POP_UP_AFTER_SAVE";
export const defaultPayerGroupFormData = {
  payerGroupId: 0,
  clientId: 0,
  name: "",
  description: null,
  effectiveDate: new Date(),
  termDate: null,
  payerGroupTypeId: null,
  pbPhysicianPmntEstId: 1,
  pbPhysPmntEstFeeScheduleId: 1,
  pbPhysPmntEstPercent: 0,
  pbPhysPmntEstUpdatedBy: null,
  pbPhysPmntEstUpdatedById: null,
  pbPhysPmntEstUpdatedDate: null,
  pbPhysPmntEstInstance: false,
  pbNppPmntEstId: 3,
  pbNppPmntEstFeeScheduleId: 2,
  pbNppPmntEstPercent: 0,
  pbNppPmntEstUpdatedBy: null,
  pbNppPmntEstUpdatedById: null,
  pbNppPmntEstUpdatedDate: null,
  pbNppPmntEstInstance: false,
  hbOutpatientPmntEstId: 5,
  hbOutpatientPmntEstFeeScheduleId: 0,
  hbOutpatientPmntEstPercent: 0,
  hbOutpatientPmntEstUpdatedBy: null,
  hbOutpatientPmntEstUpdatedById: null,
  hbOutpatientPmntEstUpdatedDate: null,
  hbOutpatientPmntEstInstance: false,
  hbInpatientPmntEstId: 8,
  hbInpatientPmntEstFeeScheduleId: 0,
  hbInpatientPmntEstPercent: 0,
  hbInpatientPmntEstUpdatedBy: null,
  hbInpatientPmntEstUpdatedById: null,
  hbInpatientPmntEstUpdatedDate: null,
  hbInpatientPmntEstInstance: false,
  availableRemitPayersList: [],
  linkedRemitPayersList: [],
  createdBy: null,
  createdDate: null,
  updatedBy: null,
  updatedDate: null,
};

const initialState = {
  isLoading: false,
  payerGroupFormData: defaultPayerGroupFormData,
  payerGroupsList: [],
  systemPayerMappingList: [],
  payerGroupTypeList: [],
  pbPhysicianPmntEstList: [],
  pbNppPmntEstList: [],
  hbOutpatientPmntEstList: [],
  hbInpatientPmntEstList: [],
  pbPhysPmntEstFeeScheduleList: [],
  pbNppPmntEstFeeScheduleList: [],
  hbOutpatientPmntEstFeeScheduleList: [],
  hbInpatientPmntEstFeeScheduleList: [],
  isPayerGroupWarningPopupVisible: false,
  closePayerGroupPopupAfterSave: false,
  supplementalDataMappingTabs: [],  
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_PAYER_GROUPS_LIST)(action)) {
        return {
          ...state,
          payerGroupsList: [],
          isLoading: false,
        };
      }
      if (isAsyncComplete(GET_PAYER_GROUPS_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          payerGroupsList: response.payerGroupsList,
          isLoading: true,
        };
      }
      if (isAsyncOperation(GET_PAYMENT_ESTIMATION_DATA_LISTS)(action)) {
        return {
          ...state,
          pbPhysicianPmntEstList: [],
          pbNppPmntEstList: [],
          hbOutpatientPmntEstList: [],
          hbInpatientPmntEstList: [],
          isLoading: false,
        };
      }
      if (isAsyncComplete(GET_PAYMENT_ESTIMATION_DATA_LISTS)(action)) {
        const response = action.response;
        return {
          ...state,
          pbPhysicianPmntEstList: response.pbPhysicianPmntEstList,
          pbNppPmntEstList: response.pbNppPmntEstList,
          hbOutpatientPmntEstList: response.hbOutpatientPmntEstList,
          hbInpatientPmntEstList: response.hbInpatientPmntEstList,
          isLoading: true,
        };
      }
      if (isAsyncOperation(GET_FEE_SCHEDULE_DATA_LISTS)(action)) {
        return {
          ...state,
          pbPhysPmntEstFeeScheduleList: [],
          pbNppPmntEstFeeScheduleList: [],
          hbOutpatientPmntEstFeeScheduleList: [],
          hbInpatientPmntEstFeeScheduleList: [],
          isLoading: false,
        };
      }
      if (isAsyncComplete(GET_FEE_SCHEDULE_DATA_LISTS)(action)) {
        const response = action.response;
        return {
          ...state,
          pbPhysPmntEstFeeScheduleList: response.pbPhysPmntEstFeeScheduleList,
          pbNppPmntEstFeeScheduleList: response.pbNppPmntEstFeeScheduleList,
          hbOutpatientPmntEstFeeScheduleList:
            response.hbOutpatientPmntEstFeeScheduleList,
          hbInpatientPmntEstFeeScheduleList:
            response.hbInpatientPmntEstFeeScheduleList,
          isLoading: true,
        };
      }
      if (isAsyncOperation(GET_PAYER_GROUP_TYPE_LIST)(action)) {
        return {
          ...state,
          payerGroupTypeList: [],
          isLoading: false,
        };
      }
      if (isAsyncComplete(GET_PAYER_GROUP_TYPE_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          payerGroupTypeList: response.payerGroupTypeList,
          isLoading: true,
        };
      }
      if (isAsyncOperation(GET_SYSTEM_PAYERS_MAPPING_LIST)(action)) {
        return {
          ...state,
          systemPayerMappingList: [],
          isLoading: false,
        };
      }
      if (isAsyncComplete(GET_SYSTEM_PAYERS_MAPPING_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          systemPayerMappingList: response.systemPayerMappingList,
          isLoading: true,
        };
      }
      return state;

    case TOGGLE_PAYER_GROUP_DETAIL_POPUP:
      return { ...state, ...action.data };

    case SET_PAYER_GROUP_FORM_DATA:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const payerGroupFormData = newState.payerGroupFormData
          ? cloneDeep(newState.payerGroupFormData)
          : {};
        for (let prop in action.data.payerGroupFormData) {
          payerGroupFormData[prop] = action.data.payerGroupFormData[prop];
        }
        newState = { ...newState, payerGroupFormData: payerGroupFormData };
      }
      return newState;

    case RESET_PAYER_GROUP_DETAIL_POPUP_VALIDATION:
    case TOGGLE_PAYER_GROUP_WARNING_POPUP:
    case CLOSE_PAYER_GROUP_POP_UP_AFTER_SAVE:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    default:
      return state;
  }
}
